/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Outline({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 17" {...props}><g stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} clipPath="url(#Outline_svg__a)"><path d="M1.398 1.5h8.22M6.382 8.5h8.22M1.398 15.5h8.22M1.398 5h8.22M6.382 12h8.22" /></g><defs><clipPath id="Outline_svg__a"><path fill="transparent" d="M0 .5h16v16H0z" /></clipPath></defs></svg>;
}
;